import "./Login.css";
import {useEffect, useState} from "react";
import {Form, Row, Col, Card, ToastContainer, Toast, ProgressBar} from "react-bootstrap";
import {useNavigate, useParams} from "react-router-dom";
import axios from "axios";
import DateTime from "../DateTime/DateTime";
import cklogo from "../../../images/cklogo.jpg";
import "../../Header/Header.css";
import {Button} from "react-bootstrap";
import {API_URL} from "../../util/Constants";

function Login() {
    const data = useParams();
    const [loginButton, setLoginButton] = useState(true);
    const [showToast, setShowToast] = useState(true);
    const [countOfProgess, setCountOfProgess] = useState(100);
    const navigate = useNavigate();
    const [userName, setUserName] = useState("");
    const [password, setPassword] = useState("");
    const [errorData, setErrorData] = useState("");
    const [submitClick, setSubmitClick] = useState(false);

    useEffect(() => {
        sessionStorage.clear();
        localStorage.clear();
        const timer = setInterval(() => {
            setCountOfProgess((oldProgress) => {
                if (0 == oldProgress) return 100;
                return Math.min(oldProgress - Math.random() * 5, 100);
            });
        }, 10);

        return () => {
            clearInterval(timer);
        };
    }, []);

    useEffect(() => {
        if (userName !== "" && password !== "") {
            setLoginButton(false);
        } else {
            setLoginButton(true);
        }
    }, [userName, password])

    const getUserDetails = (e) => {
        e.preventDefault();
        setSubmitClick(true);
        setLoginButton(true);
        let postObj = {};
        postObj.userName = userName;
        postObj.password = password;

        axios
            .post(API_URL + "loginAuth", postObj)
            .then((data) => {
                if (data.status === 200) {
                    console.log(data.data.token);
                    let responseData = data.data.data[0];
                    localStorage.setItem("token", data.data.token);
                    localStorage.setItem("userEmail", responseData.emailId);
                    if (responseData.role === "Vendor") {
                        localStorage.setItem("id", responseData.id);
                        localStorage.setItem("username", responseData.userName);
                        localStorage.setItem("role", responseData.role);
                        localStorage.setItem("branch", responseData.branchName);
                        localStorage.setItem("branchId", responseData.branchId);
                        localStorage.setItem("plantCode", responseData.branchId);
                        localStorage.setItem("vendorName", responseData.vendorName);
                        localStorage.setItem("contractName", responseData.contractName);
                        localStorage.setItem("vendorId", responseData.vendorId);
                        localStorage.setItem("genderSpecific", responseData.branchGenderBased);
                        window.location.href = "/landingPage"
                        // navigate("/landingpage", { replace: true });
                    }
                    else {
                        localStorage.setItem("id", responseData.id);
                        localStorage.setItem("username", responseData.userName);
                        localStorage.setItem("role", responseData.role);
                        localStorage.setItem("branch", responseData.branchName);
                        localStorage.setItem("branchId", responseData.branchId);
                        localStorage.setItem("plantCode", responseData.branchId);
                        localStorage.setItem("genderSpecific", responseData.branchGenderBased);
                        if(responseData.role === "Department"){
                        localStorage.setItem("departmentId", responseData.departmentId);
                        }
                        window.location.href = "/landingPage"
                        // navigate("/landingpage", { replace: true });
                    }
                }
            })
            .catch((error) => {
                if (error.response.status === 401) {
                    setErrorData("incorrect");
                    setLoginButton(false);
                    setSubmitClick(false);
                }
                console.error(error);
            });
    };

    return (<div className="App mobHeight" style={{overflow: "hidden"}}>
            <div className={"row  outlineBoxShadow"}>
                <div className=" col-12 reg-headTabsBg">
                    <div className={"col-4"}>
                        <img src={cklogo} className=" reg-samplebox-logo" alt=""/>
                    </div>
                    <Col size={4} className={"headerEmpty"}></Col>
                    <div className={"col-lg-4 col-md-4 col-sm-8 col-xs-8 m-auto"}>
                        <div className={"row"}>
                            <Col size={6} className={"headerEmpty"}></Col>
                            <Col size={4} className={"positionText"}>
                                <div>
                                    {/* <p style={{ color: "#000", fontSize: "14px", marginBottom: "0px" }}>Signed in as: <a href="#login">{username}</a></p> */}
                                </div>
                                {/* <div className={"dateTimeDiv"}>
                <DateTime />
              </div> */}
                                {/* </div> */}
                            </Col>
                        </div>
                    </div>
                </div>
                <div className="blueLine"></div>
            </div>
            <Card className="loginCard">
                <Form>
                    <h3>Sign In</h3>
                    <h3>{}</h3>
                    <div className="mb-3">
                        <Row>
                            <Form.Label column md={4} sm={4} xl={4} lg={4}>
                                User Id/ Username<sup className="required">*</sup>
                            </Form.Label>
                            <Col>
                                <Form.Control
                                    type="text"
                                    placeholder="Enter Username/userId"
                                    onChange={(e) => setUserName(e.target.value)}
                                />
                            </Col>
                        </Row>
                    </div>
                    <div className="mb-3">
                        <Row>
                            <Form.Label column md={4} sm={4} xl={4} lg={4}>
                                Password <sup className="required">*</sup>
                            </Form.Label>
                            <Col>
                                <Form.Control
                                    type="password"
                                    placeholder="Enter Password"
                                    onChange={(e) => setPassword(e.target.value)}
                                />
                            </Col>
                        </Row>
                    </div>

                    {errorData == "nullerror" && (<p style={{color: "red", fontWeight: "500", fontSize: "13px"}}>
                        Username or Password is empty !!!
                    </p>)}
                    {errorData == "incorrect" && (<p style={{color: "red", fontWeight: "500", fontSize: "13px"}}>
                        Incorrect Username or Password !!!
                    </p>)}
                    <div className="d-grid">
                        <button
                            disabled={loginButton}
                            type="submit"
                            className="btn btn-primary submitButton"
                            onClick={(e) => getUserDetails(e)}
                        >
                            <span className= {submitClick === false ? "submitText": "displayNone"}>Submit</span>
                            <span className= {submitClick === true ? " submittingText": "displayNone"}>
                                Submitting
                                  <span className="loading__dot"></span>
                                  <span className="loading__dot"></span>
                                  <span className="loading__dot"></span>
                            </span>
                        </button>
                    </div>
                    {/* <p className="forgot-password text-right">
                        Forgot <a href="#">password?</a>
                    </p> */}
                </Form>
            </Card>

            {data.login === "login" && <ToastContainer
                className="p-3 "
                position='bottom-end'
                style={{zIndex: 9}}
            >
                <Toast bg="primary" onClose={() => setShowToast(false)} show={showToast} delay={3000} autohide>
                    <Toast.Header bg='primary'>
                        <strong>SESSION EXPIRED</strong>
                    </Toast.Header>
                    <Toast.Body>Hello there !! Session Expired. Please login again.</Toast.Body>
                    <div className={"loadingProgressBar"}>

                    </div>
                </Toast>
            </ToastContainer>}

        </div>

    );
}

export default Login;
